import { useEffect, useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { toast } from "@/components/Toast";
import { ArrowDown, ArrowUp, Filter, Trash2 } from "lucide-react";
import { ClearLogsButton } from "@/components/ClearLogsButton";
import { VehicleDetailModal } from "@/components/VehicleDetail";
import { ExportButtons } from "@/components/ExportButtons"; // Fix BS

export default function AdminVehicles() {
  const [list, setList] = useState(null);
  const [clients, setClients] = useState([]);
  const [filterClient, setFilterClient] = useState("");
  const [detail, setDetail] = useState(null); // Fix BN: detalle completo del movimiento

  const load = async () => {
    try {
      const [v, c] = await Promise.all([api.get("/vehicles"), api.get("/clients")]);
      setList(v.data); setClients(c.data);
    } catch (e) { toast.error(formatApiError(e)); }
  };
  useEffect(() => { load(); }, []);

  const removeLog = async (id) => {
    if (!window.confirm("¿Eliminar este movimiento? No se puede deshacer.")) return;
    try {
      await api.delete(`/vehicles/${id}`);
      toast.success("Movimiento eliminado");
      setList((l) => l.filter((v) => v.id !== id));
    } catch (e) { toast.error(formatApiError(e)); }
  };

  const filtered = list ? (filterClient ? list.filter((v) => v.client_id === filterClient) : list) : null;

  return (
    <div style={{ padding: "20px 24px 60px" }}>
      <div style={{ fontSize: 11, letterSpacing: "0.2em", color: "#BF3437", fontWeight: 700, textTransform: "uppercase" }}>Operación</div>
      <h1 style={{ fontSize: 32, fontWeight: 900, margin: "4px 0 18px", color: "#0A0A0A", letterSpacing: "-0.02em" }}>Movimientos de vehículos</h1>

      <div className="card" style={{ display: "flex", gap: 10, alignItems: "flex-end", padding: 14, marginBottom: 14, flexWrap: "wrap" }}>
        <Filter size={16} style={{ color: "#BF3437", alignSelf: "center" }} />
        <div className="field" style={{ marginBottom: 0, flex: 1, minWidth: 220 }}>
          <label>Cliente</label>
          <select value={filterClient} onChange={(e) => setFilterClient(e.target.value)} data-testid="veh-filter-client">
            <option value="">Todos</option>
            {clients.map((c) => <option key={c.id} value={c.id}>{c.name}</option>)}
          </select>
        </div>
        <ExportButtons kind="vehicles" rows={filtered} testIdPrefix="veh" filtersLabel={filterClient ? `Objetivo: ${clients.find((c) => c.id === filterClient)?.name || ""}` : ""} />
        <ClearLogsButton endpoint="/vehicles" clients={clients} label="vehículos" onDone={load} testidPrefix="veh" />
      </div>

      <div className="card" style={{ padding: 0, overflow: "hidden" }}>
        {filtered == null && <div style={{ padding: 20 }}><div className="skel" style={{ height: 60 }} /></div>}
        {filtered && filtered.length === 0 && <div style={{ padding: 40, textAlign: "center", color: "var(--invict-text-muted)" }}>Sin movimientos.</div>}
        {filtered && filtered.map((v) => (
          <div key={v.id} onClick={() => setDetail(v)} style={{ padding: "12px 20px", borderBottom: "1px solid var(--invict-bone-3)", display: "grid", gridTemplateColumns: "auto 1fr 2fr 2fr 2fr auto", gap: 12, alignItems: "center", cursor: "pointer" }} data-testid={`veh-row-${v.id}`}>
            <div style={{ width: 32, height: 32, borderRadius: "50%", background: v.direction === "entrada" ? "#16a34a" : "#BF3437", color: "white", display: "grid", placeItems: "center" }}>
              {v.direction === "entrada" ? <ArrowDown size={14}/> : <ArrowUp size={14}/>}
            </div>
            <div style={{ fontFamily: "monospace", fontWeight: 800, letterSpacing: "0.1em", fontSize: 14 }}>{v.plate}</div>
            <div style={{ fontSize: 13 }}>{v.client_name}</div>
            <div style={{ fontSize: 12, color: "var(--invict-text-muted)" }}>
              {v.description || "—"}{v.reason && <div>{v.reason}</div>}
              {(v.driver_name || v.driver_surname) && <div>Conductor: {[v.driver_surname, v.driver_name].filter(Boolean).join(", ")}</div>}
            </div>
            <div style={{ fontSize: 11, color: "var(--invict-text-muted)" }}>{v.user_name} · {new Date(v.created_at).toLocaleString("es-AR")}</div>
            <button type="button" onClick={(e) => { e.stopPropagation(); removeLog(v.id); }} title="Eliminar movimiento"
              style={{ padding: 7, border: "1px solid var(--invict-bone-3)", background: "white", color: "#BF3437", borderRadius: 2, cursor: "pointer" }}
              data-testid={`veh-delete-${v.id}`}>
              <Trash2 size={14} />
            </button>
          </div>
        ))}
      </div>
      <VehicleDetailModal vehicle={detail} onClose={() => setDetail(null)} />
    </div>
  );
}
